import React from "react";

const cards = [
  { key: "total", label: "Total", accent: "primary", icon: "bi-collection" },
  { key: "activas", label: "Activas", accent: "success", icon: "bi-lightning" },
  { key: "pendientesPago", label: "Pendiente de pago", accent: "warning", icon: "bi-cash-coin" },
  { key: "pagoParcial", label: "Pago parcial", accent: "info", icon: "bi-wallet2" },
  { key: "pagadas", label: "Pagadas", accent: "secondary", icon: "bi-check-circle" },
  { key: "finalizadas", label: "Finalizadas", accent: "dark", icon: "bi-flag" },
];

export default function MatriculasSummary({ resumen = {}, onQuickFilter, activeKey }) {
   const handleKey = (key) => {
    onQuickFilter?.(key);
  };

  return (
    <div className="management-card mb-4">
      <div className="matriculas-summary-grid">
        {cards.map((card) => {
          const isActive = activeKey === card.key;
          const accentClass = card.accent ? `accent-${card.accent}` : "";
          return (
            <div key={card.key} className="w-100">
              <div
                className={`management-stat-card matriculas-summary-card h-100 ${accentClass} ${isActive ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleKey(card.key)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleKey(card.key);
                  }
                }}
              >
                <div className="management-stat-icon">
                  <i className={`bi ${card.icon}`} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{card.label}</p>
                  <div className="management-stat-value">{resumen[card.key] ?? 0}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
